import { uploadTag } from "api/tags";

const tagsFileUploaderApiConfig = {
  uploadTag
};

export default tagsFileUploaderApiConfig;